// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `button.button--submit-btn[data-v-2ba5a154]:disabled,
button.button--submit-btn[disabled][data-v-2ba5a154] {
  cursor: not-allowed !important;
}
.table-text td[data-v-2ba5a154],
.table-text th[data-v-2ba5a154],
.table-text a[data-v-2ba5a154] {
  font-size: 11px;
}
`, "",{"version":3,"sources":["webpack://./src/js/pages/application/review_signature/review.vue","webpack://./review.vue"],"names":[],"mappings":"AACA;;EACI,8BAAA;ACCJ;ADEA;;;EAEI,eAAA;ACCJ","sourcesContent":["\nbutton.button--submit-btn:disabled, button.button--submit-btn[disabled]{\n    cursor: not-allowed !important;\n}\n\n.table-text td, .table-text th,\n.table-text a {\n    font-size: 11px;\n}\n","button.button--submit-btn:disabled,\nbutton.button--submit-btn[disabled] {\n  cursor: not-allowed !important;\n}\n.table-text td,\n.table-text th,\n.table-text a {\n  font-size: 11px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
